import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/video.vue
var o = {
	name: "DtIconVideo",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--video"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Video",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M2 3.003a.5.5 0 0 0-.5.5v4.994a.5.5 0 0 0 .5.5h5.502a.5.5 0 0 0 .5-.5V3.503a.5.5 0 0 0-.5-.5H2Zm7.002 1.252v-.752a1.5 1.5 0 0 0-1.5-1.5H2a1.5 1.5 0 0 0-1.5 1.5v4.994a1.5 1.5 0 0 0 1.5 1.5h5.502a1.5 1.5 0 0 0 1.5-1.5v-.765l1.812.726a.5.5 0 0 0 .686-.465v-4a.5.5 0 0 0-.686-.464l-1.812.726Zm0 1.077v1.323l1.498.6V4.732l-1.498.6Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=video.js.map